  export class Movimientopago {
    constructor(
      public idusuario: string,
      public idempresa: string,
      public idprecompra: string,
      public idpescador: string,
      public concepto: string,
      public barco: string,
      public lcompradas: number,
      public lsolicitado: number,
      public entransito: number,
      public ldisponible: number,
      public fecha?: Date,
      public numerosolicitud?: string,
      public numeroperacion?: string,
      public procesado?: boolean,
      public deprecompra?: boolean,
      public tipolicencias?: string

     ) { }
  }




